// Программа ПК «Экспорт высокотехнологичной продукции» (Заявка №2).
// Заводится на каждом окружении отдельно, поэтому её ID берётся из .env*, а не зашит в код.
export const HITECH_PROGRAM_ID: number = Number(process.env.VUE_APP_HITECH_PROGRAM_ID) || 0;

export function isHitechProgram(id: number | string | null | undefined): boolean {
  return HITECH_PROGRAM_ID > 0 && Number(id) === HITECH_PROGRAM_ID;
}
